import React, { useState, useEffect } from 'react';
import './DashboardLayout.css';
import DashboardSidebar from './DashboardSidebar';
import DashboardContent from './DashboardContent';

const DashboardLayout = ({ user, onLogout }) => {
  const [activeSection, setActiveSection] = useState('hero');
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const sections = [
    { id: 'hero', name: 'القسم الرئيسي', icon: '🏠' },
    { id: 'about', name: 'قسم من نحن', icon: 'ℹ️' },
    { id: 'services', name: 'الخدمات', icon: '💼' },
    { id: 'portfolio', name: 'المشاريع', icon: '🖼️' },
    { id: 'steps', name: 'قسم الخطوات', icon: '📋' },
    { id: 'why-choose-us', name: 'لماذا تختارنا', icon: '⭐' },
    { id: 'contact', name: 'قسم التواصل', icon: '📧' },
    { id: 'footer', name: 'التذييل', icon: '🔗' },
    { id: 'navbar', name: 'القائمة', icon: '📱' },
    { id: 'social-media', name: 'التواصل الاجتماعي', icon: '📱' },
    { id: 'contact-details', name: 'بيانات التواصل', icon: '📞' },
    { id: 'messages', name: 'الرسائل', icon: '📬' },
    { id: 'settings', name: 'الإعدادات', icon: '⚙️' },
  ];

  return (
    <div className="dashboard-layout">
      <DashboardSidebar
        sections={sections}
        activeSection={activeSection}
        onSectionChange={setActiveSection}
        user={user}
        onLogout={onLogout}
        isOpen={sidebarOpen}
        onToggle={() => setSidebarOpen(!sidebarOpen)}
      />
      <div className={`dashboard-main-content ${!sidebarOpen ? 'sidebar-closed' : ''}`}>
        <DashboardContent
          activeSection={activeSection}
          user={user}
        />
      </div>
    </div>
  );
};

export default DashboardLayout;

